import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { BACKEND_URL, authHeaders, clearAuthToken, getSessionId } from '../lib/utils';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/me?session_id=${encodeURIComponent(getSessionId())}`, {
        credentials: 'include',
        headers: { ...authHeaders() },
      });
      if (res.ok) {
        const u = await res.json();
        setUser(u);
      } else {
        setUser(false);
      }
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    await fetch(`${BACKEND_URL}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include',
      headers: { ...authHeaders() },
    });
    clearAuthToken();
    // Rigenera session_id per non mostrare dati personali dopo logout
    const newId = 'sess_' + Math.random().toString(36).substr(2, 12);
    localStorage.setItem('scanmarket_session', newId);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
